import { ACTION } from '../../../../../shared/constants'

const {
  callAuthorizedGraphQLEndpoint,
} = require('../../../../../Module/graphQL')

const getEmailTemplate = ({ id }) => {
  const query = `
    query getEmailsTemplate($id: ID!){
        city(id:$id){
            emailsTemplate{
                id
                cityId
                name
                sender
                cc
                bcc
                subject
                body
                files{
                    id
                    fileName
                    fileUrl
                }
                customDynamicValues
            }
      }
    }
  `
  return callAuthorizedGraphQLEndpoint(query, {
    id,
  })
}

const createEmailTemplate = async input => {
  const query = `
    mutation createEmailTemplate($input:CreateEmailTemplateInput!){
      createEmailTemplate(input: $input){
          id
          name
          sender
          cc
          bcc
          subject
          body
          files{
              id
              fileName
              fileUrl
          }
customDynamicValues
      }
  }
  `

  return await callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

const editEmailTemplate = async input => {
  const query = `
mutation editEmailTemplate($input:EditEmailTemplateInput!){
    editEmailTemplate(input: $input){
        id
        name
        sender
        cc
        bcc
        subject
        body
        files{
            id
            fileName
            fileUrl
        }
        customDynamicValues
    }
}
`

  return await callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

const deleteEmailTemplate = async input => {
  const query = `
mutation deleteEmailTemplate($input:DeleteEmailTemplateInput!){
    deleteEmailTemplate(input: $input){
        id
    }
}
`
  return await callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

const deletePushNotificationTemplate = async id => {
  const query = `
    mutation deletePushNotificationTemplate($id:ID!){
        deletePushNotificationTemplate(id: $id){
          success
          error
        }
    }
  `
  return await callAuthorizedGraphQLEndpoint(query, {
    id,
  })
}

const createPushNotificationTemplate = async input => {
  const query = `
    mutation createPushNotificationTemplate($input:CreatePushNotificationTemplateInput!){
      createPushNotificationTemplate(input: $input){
        id
        title
        body
        name
        route
      }
    }
  `

  return await callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

const editPushNotificationTemplate = async input => {
  const query = `
    mutation editPushNotificationTemplate($input:EditPushNotificationTemplateInput!){
      editPushNotificationTemplate(input: $input){
        id
        title
        body
        name
        route
      }
    }
  `

  return await callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

const createSMSNotificationTemplate = async input => {
  const query = `
    mutation createSMSNotificationTemplate($input:CreateSMSNotificationTemplateInput!){
      createSMSNotificationTemplate(input: $input){
        id
        body
        name
        success
      }
    }
  `

  return await callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

const editSMSNotificationTemplate = async input => {
  const query = `
    mutation editSMSNotificationTemplate($input:EditSMSNotificationTemplateInput!){
      editSMSNotificationTemplate(input: $input){
        id
        body
        name
        success
      }
    }
  `

  return await callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

const deleteSMSNotificationTemplate = async id => {
  const query = `
    mutation deleteSMSNotificationTemplate($id:ID!){
        deleteSMSNotificationTemplate(id: $id){
          success
          error
        }
    }
  `
  return await callAuthorizedGraphQLEndpoint(query, {
    id,
  })
}

const findPipeline = async ({
  id,
  cityId,
  stageName,
  name,
  status,
  stats,
  addTemplates,
}) => {
  const query = `
    query findPipeline($id: ID, $cityId: String, $stageName: String, $name: String, $status: String, $stats: Boolean, $addTemplates: Boolean) {
      findPipeline(input: {
        id: $id,
        city: $cityId,
        stage: $stageName,
        name: $name,
        status: $status
        stats: $stats
        addTemplates: $addTemplates
      })
    }
    `
  return await callAuthorizedGraphQLEndpoint(query, {
    id,
    cityId,
    stageName: stageName === 'all' ? undefined : stageName,
    name,
    status,
    stats,
    addTemplates,
  })
}

const sequenceCount = async ({ cityId }) => {
  const query = `
    query ($cityId: ID!) {
      sequenceCount(cityId: $cityId) {
        active
        archived
      }
    }
    `
  return await callAuthorizedGraphQLEndpoint(query, {
    cityId,
  })
}

const createPipeline = async ({
  cityId,
  stage,
  name,
  templateId,
  timing,
  triggerType,
  condition,
  constant,
}) => {
  const query = `
    mutation createPipeline (
      $cityId: String!, 
      $stage: String!, 
      $name: String!, 
      $templateId: ID!, 
      $timing: String!, 
      $triggerType: String!, 
      $condition: String, 
      $constant: String
    ) {
      createPipeline(
        input: {
          city: $cityId
          stage: $stage
          name: $name
          templateId: $templateId
          timing: $timing
          triggerType: $triggerType
          condition: $condition
          constant: $constant
        }
      )
    }
  `

  return await callAuthorizedGraphQLEndpoint(query, {
    cityId,
    stage,
    name,
    templateId,
    timing,
    triggerType,
    condition,
    constant,
  })
}

const editPipeline = async input => {
  const query = `
    mutation editSequence($input:EditEmailTemplateInput!){
      editSequence(input: $input){
        id
        name
        sender
        cc
        bcc
        subject
        body
        files{
          id
          fileName
          fileUrl
        }
      }
    }
  `

  return await callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

const deletePipeline = async ({ id }) => {
  const query = `
    mutation deletePipeline($id: ID!){
      deletePipeline(sequenceId: $id)
    }
  `
  return await callAuthorizedGraphQLEndpoint(query, {
    id,
  })
}

const createSequence = async ({ cityId, stage, name, username }) => {
  const query = `
    mutation createSequence (
      $cityId: String!
      $name: String!
      $stage: String!
      $username: String!
    ) {
      createSequence(input: {
        city: $cityId,
        name: $name,
        stage: $stage,
        owner: $username
      })
    }
  `

  return await callAuthorizedGraphQLEndpoint(query, {
    cityId,
    stage,
    name,
    username,
  })
}

const duplicateAllSequences = async ({ cityId }) => {
  const query = `
    mutation duplicateAllSequences (
      $cityId: ID!
    ) {
      duplicateAllSequences(input: {
        cityId: $cityId
      }) {
        success
        error
      }
    }
  `

  return await callAuthorizedGraphQLEndpoint(query, {
    cityId,
  })
}

const duplicateSelectedSequencesForCities = async ({
  cityIds,
  sequenceIds,
  originalCityId,
}) => {
  const query = `
    mutation duplicateSequencesToCities (
      $cityIds: [ID]!
      $sequenceIds: [ID]!
      $originalCityId: ID!
    ) {
      duplicateSequencesToCities(input: {
        cityIds: $cityIds,
        sequenceIds: $sequenceIds,
        originalCityId: $originalCityId
      }) {
        success
        error
        failedCities { name }
      }
    }
  `

  return await callAuthorizedGraphQLEndpoint(query, {
    cityIds,
    sequenceIds,
    originalCityId,
  })
}

const getSequences = async ({ id, cityId, name, stage, status }) => {
  const query = `
    query getSequences($id: ID, $cityId: String, $name: String, $stage: String, $status: String) {
      getSequences(input: {
        id: $id
        city: $cityId
        name: $name
        stage: $stage
        status: $status
      })
    }
  `
  return await callAuthorizedGraphQLEndpoint(query, {
    id,
    cityId,
    name,
    stage,
    status,
  })
}

const editSequence = async ({ id, name, stage, status }) => {
  const query = `
    mutation updateSequence (
      $id: ID!
      $name: String
      $stage: String
      $status: String
    ) {
      updateSequence(input: {
        id: $id,
        name: $name,
        stage: $stage
        status: $status
      })
    }
  `

  return await callAuthorizedGraphQLEndpoint(query, {
    id,
    name,
    stage,
    status,
  })
}

const editSequenceBulk = async ({ sequences }) => {
  const query = `
   mutation bulkUpdateSequences($input: BulkUpdateSequencesInput!) {
      bulkUpdateSequences(input: $input) 
    }
  `

  return await callAuthorizedGraphQLEndpoint(query, {
    input: {
      sequences,
    },
  })
}

const findIfHasStats = async ({ sequenceId }) => {
  const query = `
    query sequenceIdHasStats($sequenceId: ID){
      sequenceIdHasStats(input: {
        sequenceId: $sequenceId
      })
    }`
  return await callAuthorizedGraphQLEndpoint(query, {
    sequenceId,
  })
}

const deleteSequence = async ({ id }) => {
  const query = `
    mutation deleteSequence($id: ID!){
      deleteSequence(
        id: $id
      )
    }
  `
  return await callAuthorizedGraphQLEndpoint(query, {
    id,
  })
}

const createSchedule = async ({ sequenceId, startDate }) => {
  const query = `
    mutation ($dateSequenceTemplate: CreateDateSequenceTemplateInput) {
      createDateSequenceTemplate(input: $dateSequenceTemplate)
    }
  `
  return await callAuthorizedGraphQLEndpoint(query, {
    dateSequenceTemplate: { sequenceId, startDate },
  })
}

const editSchedule = async ({ id, sequenceId, startDate }) => {
  const query = `
    mutation ($dateSequenceTemplate: UpdateDateSequenceTemplateInput) {
      updateDateSequenceTemplate(input: $dateSequenceTemplate) 
    }
  `
  return await callAuthorizedGraphQLEndpoint(query, {
    dateSequenceTemplate: { id, sequenceId, startDate },
  })
}

const deleteSchedule = async id => {
  const query = `
    mutation ($id: ID) {
      deleteDateSequenceTemplate(id: $id)
    }
  `
  return await callAuthorizedGraphQLEndpoint(query, { id })
}

const createTrigger = async ({
  sequenceId,
  triggerType,
  condition,
  constant,
}) => {
  const query = `
    mutation createTrigger (
      $sequenceId: ID!,
      $triggerType: String!,
      $condition: String,
      $constant: String
    ) {
      createTrigger(input: {
        sequenceId: $sequenceId,
        triggerType: $triggerType,
        condition: $condition,
        constant: $constant
      })
    }
  `
  return await callAuthorizedGraphQLEndpoint(query, {
    sequenceId,
    triggerType,
    condition,
    constant,
  })
}

const editTrigger = async ({ triggerId, constant, triggerType, condition }) => {
  const query = `
    mutation updateTrigger(
      $triggerId: ID!, 
      $constant: String!, 
      $triggerType: String!, 
      $condition: String
    ) {
      updateTrigger(input: {
        triggerId: $triggerId,
        constant: $constant,
        triggerType: $triggerType,
        condition: $condition
      })
    }`
  return await callAuthorizedGraphQLEndpoint(query, {
    triggerId,
    constant,
    triggerType,
    condition,
  })
}

const deleteTrigger = async ({ triggerId }) => {
  const query = `
    mutation deleteTrigger($triggerId: ID!){
      deleteTrigger(
        triggerId: $triggerId
      )
    }
  `
  return await callAuthorizedGraphQLEndpoint(query, {
    triggerId,
  })
}

const createAction = async ({
  sequenceId,
  templateId,
  timing,
  actionTypeId,
}) => {
  const query = `
    mutation createAction (
      $actionTypeId: ID!,
      $sequenceId: ID!,
      $templateId: ID!,
      $timing: String!
    ) {
      createAction(input: {
        sequenceId: $sequenceId,
        templateId: $templateId,
        timing: $timing,
        actionTypeId: $actionTypeId
      })
    }
  `
  return await callAuthorizedGraphQLEndpoint(query, {
    sequenceId,
    templateId,
    timing,
    actionTypeId,
  })
}

const editAction = async ({ actionId, timing }) => {
  const query = `
    mutation updateAction(
      $actionId: ID!,
      $timing: String!
    ) {
      updateAction(input: {
        actionId: $actionId,
        timing: $timing
      })
    }
  `
  return await callAuthorizedGraphQLEndpoint(query, {
    actionId,
    timing,
  })
}

const deleteAction = async ({ actionId }) => {
  const query = `
    mutation deleteAction($actionId: ID!){
      deleteAction(
        actionId: $actionId
      )
    }
  `
  return await callAuthorizedGraphQLEndpoint(query, {
    actionId,
  })
}

const findEmailStat = async ({
  messageId,
  sequenceId,
  state,
  orderBy,
  order,
}) => {
  const query = `
    query findEmailStat(
        $messageId: ID, 
        $sequenceId: ID, 
        $orderBy: String, 
        $order: String,
        $state: [String],
      ) {
      findEmailStat(
        input: {
          messageId: $messageId,
          sequenceId: $sequenceId,
          state: $state,
          filters: { orderBy: $orderBy, order: $order }
        }
      ) {
        sequenceId
        messageId
        openCount
        clicksCount
        sentAt
        firstName
        lastName
        emailName
        userId
        state
      }
    }
    `
  return await callAuthorizedGraphQLEndpoint(query, {
    messageId,
    sequenceId,
    state,
    orderBy,
    order,
  })
}

const blockUser = async ({ userId }) => {
  const query = `
    mutation updateUserData($userId: ID!) {
      updateUserData(input: {
        blockedReason: "Poor results"
        id: $userId
        statusV2: 2
        unbookMissions: false
      }) {
        user {
          id
        }
      }
    }
  `
  return await callAuthorizedGraphQLEndpoint(query, {
    userId,
  })
}

const getDefaultEmailVariables = async () => {
  const query = `
    query getDefaultEmailVariables {
      getDefaultEmailVariables
    }
  `
  const response = await callAuthorizedGraphQLEndpoint(query)
  return response.json()
}

const findEmailStatWithTemplate = async ({
  templateIds,
  sequenceId,
  cityId,
}) => {
  const query = `
    query findEmailStatWithTemplate($templateIds: [TemplateIdsInput], $sequenceId: ID $cityId: ID) {
      findEmailStatWithTemplate(input: {
        templateIds: $templateIds,
        sequenceId: $sequenceId,
        cityId: $cityId
      }) {
        templateId
        email
        name
        subject
        openCount
        clicksCount
        sent
        title
        body
        type
      }
    }
  `
  return await callAuthorizedGraphQLEndpoint(query, {
    templateIds,
    sequenceId,
    cityId,
  })
}

const previewEmailTemplate = async ({ templateName, cityId }) => {
  const query = `
    mutation ($templateName: String!, $cityId: ID) {
      previewEmailTemplate(
        input: { templateName: $templateName, cityId: $cityId }
      ) {
        html
        text
        subject
      }
    }
  `
  return await callAuthorizedGraphQLEndpoint(query, { templateName, cityId })
}

const sendActionSimulation = async ({
  action = ACTION.EMAIL,
  actionId,
  receiver,
  userId,
}) => {
  const query = `
    mutation sendActionSimulation($input: sendActionSimulationInput!){
      sendActionSimulation(
        input: $input
      )
    }
  `
  const response = await callAuthorizedGraphQLEndpoint(
    query,
    {
      input: { action, actionId, receiver, userId },
    },
    { doNotShowErrorModal: true },
  )

  return response.json()
}

const getCitiesForSequenceDuplication = async ({ countryId }) => {
  const query = `
  query (
    $id: ID!,
  ) {
      country(id: $id) {
          cities {
            edges {
              node {
                id
                name
                statusV2
              }
            }
          }
        }
      }`
  return await callAuthorizedGraphQLEndpoint(query, { id: countryId })
}

const checkIfCitiesHaveSequences = async ({ cityIds, sequenceIds }) => {
  const query = `
    query checkIfCitiesHaveSequences (
      $cityIds: [ID]!
      $sequenceIds: [ID]!
    ) {
      checkIfCitiesHaveSequences(
        cityIds: $cityIds,
        sequenceIds: $sequenceIds,
      ) {
        citiesWithSequences {
            cityName
            cityId
            sequences
          }
      }
    }
  `

  return await callAuthorizedGraphQLEndpoint(query, {
    cityIds,
    sequenceIds,
  })
}

export {
  getEmailTemplate,
  createEmailTemplate,
  editEmailTemplate,
  deleteEmailTemplate,
  createPushNotificationTemplate,
  editPushNotificationTemplate,
  deletePushNotificationTemplate,
  createSMSNotificationTemplate,
  editSMSNotificationTemplate,
  deleteSMSNotificationTemplate,
  findPipeline,
  createPipeline,
  editPipeline,
  deletePipeline,
  createSequence,
  duplicateAllSequences,
  getSequences,
  editSequence,
  deleteSequence,
  createTrigger,
  editTrigger,
  deleteTrigger,
  createAction,
  editAction,
  deleteAction,
  findEmailStat,
  blockUser,
  getDefaultEmailVariables,
  findEmailStatWithTemplate,
  previewEmailTemplate,
  sendActionSimulation,
  sequenceCount,
  createSchedule,
  editSchedule,
  deleteSchedule,
  findIfHasStats,
  getCitiesForSequenceDuplication,
  duplicateSelectedSequencesForCities,
  checkIfCitiesHaveSequences,
  editSequenceBulk,
}
